import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ConsultYourGuideComponent} from './consult-your-guide.component';

const routes: Routes = [
    {
        path: 'consult-your-guide',
        component: ConsultYourGuideComponent,
        data: {animation: 'consult-your-guide', pageTitle: 'Consult Your Guide'}
    },
    {
        path: 'ai-chat-leads',
        component: ConsultYourGuideComponent,
        data: {animation: 'ai-chat-leads', pageTitle: 'AI Chat Leads', source: 'ai_chat'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class ConsultYourGuideRoutingModule {
}
